/*
 * @Author: Xu Xingshan 
 * @Date: 2019-03-20 23:02:18 
 * @Last Modified by: Xu Xingshan
 * @Last Modified time: 2019-06-05 23:05:31
 */
import { Injectable, EventEmitter, Inject, Injector } from '@angular/core';
import { ToastController, NavController } from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";
import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { LocalStorageService } from '../service/localstorage.service';
import { SigningKeyService } from './signing-key.service';
import { RequestSigningService } from './request-signing.service';
import { APPConfig } from '../config/env';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public userInfoEvent: EventEmitter<any> = new EventEmitter();
  isContractor: boolean = this.localStorageService.getStore('partyEmployee') === 'true' ? true : false; // 是否是承包商
  isLoggingOut = false;
  // public notify: EventEmitter<any> =  new EventEmitter();
  // public geohash: string = '';
  // public shopId: string = '';
  // public searchAddress: any;
  // public choosedAddress: {address: string, index: number} = {address: '', index: 0};
  // public confirmRemark: {remarkText: string, inputText: string} = {remarkText: '', inputText: ''};
  // public orderDetail: any;

  // getTabPagesIndex(pageName) {
  //   const tabPagesIndex: any = {'MsitePage': 0, 'SearchPage': 1, 'OrderPage': 2, 'ProfilePage': 3};
  //   return tabPagesIndex[pageName];
  // }
  constructor(
    public toastController: ToastController,
    public navController: NavController,
    @Inject(DOCUMENT) private document: Document,
    public localStorageService:LocalStorageService,
    public translateService:TranslateService,
    private injector: Injector,
    private http: HttpClient) {
  }
  async toastTip(message: string, needsTran: boolean, duration?: number) {
    let msg = message;
    if (needsTran) {
      msg = this.translateService.instant(message);
    }
    const toast = await this.toastController.create({
        message: msg,
        duration: duration ? duration : 3000,
        position: 'bottom',
        showCloseButton:true,
        closeButtonText:this.translateService.instant('common.close'),
        cssClass: 'tips-class'
      });
    toast.present();
  }

  async toastTipErrorCode(errorCode: string | number, message: string, needsTran: boolean, duration?: number) {
    let msg = message;
    if (needsTran) {
      msg = this.translateService.instant(message);
    }
    let fullMessage = '';
    fullMessage += this.translateService.instant('ERROR_TOAST_SECTION.ERROR_CODE_LABEL');
    fullMessage += (errorCode + '');
    fullMessage += this.translateService.instant('ERROR_TOAST_SECTION.ERROR_MESSAGE_LABEL');
    fullMessage += msg;
    const toast = await this.toastController.create({
        message: fullMessage,
        duration: duration ? duration : 3000,
        position: 'bottom',
        showCloseButton:true,
        closeButtonText:this.translateService.instant('common.close'),
        cssClass: 'tips-class'
      });
    toast.present();
  }

  async toastTipSuccess(message: string, needsTran: boolean, duration?: number) {
    let msg = message;
    if (needsTran) {
      msg = this.translateService.instant(message);
    }
    const toast = await this.toastController.create({
        message: msg,
        duration: duration ? duration : 3000,
        position: 'bottom',
        showCloseButton:true,
        closeButtonText:this.translateService.instant('common.close'),
        cssClass: 'tips-class-success'
      });
    toast.present();
  }

  setGlobalFontSize(fontSizePX) {
    console.log("fontSizePX");
    console.log(fontSizePX);
    this.document.documentElement.style.fontSize = fontSizePX;
  }

  formatDate(str,only){
    only = true;
    if(!str){
      return "";
    }
    if(only){
      return moment(str).format("YYYY-MM-DD");
    }else{
      var lang = this.localStorageService.getStore("APP_LANG");
      moment.locale(lang); 
      if(moment(str).diff(moment())<-1000*24*60*60 ||moment(str).diff(moment())>0){
        return moment(str).format("YYYY-MM-DD")
      }else{
        return moment(str).fromNow();
      }
    }
  }

  formatTime(str, only){
    only = true;
    if(!str){
      return "";
    }
    if(only){
      return moment(str).format("YYYY-MM-DD HH:mm:ss");
    }else{
      var lang = this.localStorageService.getStore("APP_LANG");
      moment.locale(lang); 
      if(moment(str).diff(moment())<-1000*24*60*60 ||moment(str).diff(moment())>0){
        return moment(str).format("YYYY-MM-DD HH:mm:ss")
      }else{
        return moment(str).fromNow();
      }
    }
  }

  convertCodeToTxt(str, txt){
    let desc="";
    try{
      let lang =this.localStorageService.getStore("APP_LANG")
      let txtObj = JSON.parse(txt)||null;
      if(!txtObj[str]||!txt){
        return str;
      }
      switch(lang){
        case "zh_CN":{
          desc = txtObj[str].code_desc_zh;
          break;
        }
        case "zh_TW":{
          desc = txtObj[str].code_desc_tr;
          break;
        }
        case "en_US":{
          desc = txtObj[str].code_desc_en;
          break;
        }
        case "vi":{
          desc = txtObj[str].code_desc_vi;
          break;
        }
        case "km":{
          desc = txtObj[str].code_desc_km;
          break;
        }
        case "th":{
          desc = txtObj[str].code_desc_th;
          break;
        }
        case "lo":{
          desc = txtObj[str].code_desc_lo;
          break;
        }
      }
      return desc;
    }catch{
      return desc;
    }
  } 

  translateSystemCode(str,obj){
    let desc="";
    try{
      let lang =this.localStorageService.getStore("APP_LANG")
      if(!obj){
        return str;
      }
      switch(lang){
        case "zh_CN":{
          desc = obj.code_desc_zh;
          break;
        }
        case "zh_TW":{
          desc = obj.code_desc_tr;
          break;
        }
        case "en_US":{
          desc = obj.code_desc_en;
          break;
        }
        case "vi":{
          desc = obj.code_desc_vi;
          break;
        }
        case "km":{
          desc = obj.code_desc_km;
          break;
        }
        case "th":{
          desc = obj.code_desc_th;
          break;
        }
        case "lo":{
          desc = obj.code_desc_lo;
          break;
        }
      }
      return desc;
    }catch{
      return desc;
    }
  } 

  quickCodeToArray(str) {
    if (!str) {
      return [];
    }
    try {
      let lang = this.localStorageService.getStore("APP_LANG");
      let data = JSON.parse(this.localStorageService.getStore(str));
      if (!data) {
        return [];
      }
      switch (lang) {
        case "zh_CN":{
          data.forEach((element,index) => {
            element.desc = element.code_desc_zh;
            data[index] = element;
          });
          break;
        }
        case "zh_TW":{
          data.forEach((element,index) => {
            element.desc = element.code_desc_tr;
            data[index] = element;
          });
          break;
        }
        case "en_US":{
          data.forEach((element,index) => {
            element.desc = element.code_desc_en;
            data[index] = element;
          });
          break;
        }
        case "vi":{
          data.forEach((element,index) => {
            element.desc = element.code_desc_vi;
            data[index] = element;
          });
          break;
        }
        case "km":{
          data.forEach((element,index) => {
            element.desc = element.code_desc_km;
            data[index] = element;
          });
          break;
        }
        case "th":{
          data.forEach((element,index) => {
            element.desc = element.code_desc_th;
            data[index] = element;
          });
          break;
        }
        case "lo":{
          data.forEach((element,index) => {
            element.desc = element.code_desc_lo;
            data[index] = element;
          });
          break;
        }
      }
      return data;
    } catch {
      return [];
    }
  }

  log(msg) {
    console.log(msg);
  }

    // cron表达式转成循环条件
    // cron 为空的为单次循环
    // 29 29 16 * * ? * 按天
    // 19 30 16 * * 2,3 * 按周
    // 44 30 16 2,4,21 * ? * 按月
    // 提取特殊字符串长度（scrstr 源字符串 armstr 特殊字符）
    cronChangeDate (str) {
      var toDate={loopType:"",loopValue:"",loopTime:""};
      if (!str) {
        toDate.loopType = '单次'
      } else {
        var result = str.split(' ').join('')
        var nArr = str.split(' ')
        var countData = this.getPlaceholderCount(result)
        if (!countData.count1) { // 没有'?'则是按周循环
          toDate.loopType = '每周'
          var keys = nArr[5]
          var en2cnMap = {
            1: '周天',
            2: '周一',
            3: '周二',
            4: '周三',
            5: '周四',
            6: '周五',
            7: '周六'
          }
          var cnKeys = keys.split(',').map(function (key, idx) {
            return en2cnMap[key];
          })
          toDate.loopValue = cnKeys.join(',')
        } else if (countData.count1 + countData.count2 === 3) {
          toDate.loopType = '每月'
          var mot = []
          var mkeys = nArr[3].split(',')
          for (var i = 0; i < mkeys.length; i++) {
            let mo = mkeys[i] + '日'
            mot.push(mo)
          }
          toDate.loopValue = mot.join(',')
        } else {
          toDate.loopType = '每天'
        }
        toDate.loopTime = nArr[2] + ':' + nArr[1] + ':' + nArr[0]
      }
    return toDate
      // console.log(toDate)  {loopType: "月循环", loopValue: "2号,4号,21号", loopTime: "16:30:44"}
    }
      // 统计字符串中包含某个字符的个数
    getPlaceholderCount (strSource) {
        var count1 = 0 // ?的个数
        var count2 = 0 // *的个数
        strSource.replace(/\*|\?/g, function (m, i) {
          if (m === '?') {
            count1++
          } else if (m === '*') {
            count2++
          }
        });
        var obj={count1:0,count2:0};
        obj.count1 = count1
        obj.count2 = count2
        return obj //返回一个对象，根据需要得到想要的值
    }

    logout() {
      if (this.isLoggingOut) { return; }
      this.isLoggingOut = true;
      // 通过 Injector 延迟解析，避免与 JWTInterceptor 间接形成的循环依赖
      const signingKey = this.injector.get(SigningKeyService, null);
      const requestSigning = this.injector.get(RequestSigningService, null);
      const token = localStorage.getItem('token') || '';

      const finalize = () => {
        // 退出登录清空 localStorage 前先取出这几个环境配置项以便清空后原样恢复；
        // 若此时它们本身是空的（异常场景），不能直接把 null 写回去——
        // localStorage.setItem 会把 null 存成字符串 "null"，之后 initConfig() 的
        // `if (!API_DOMAIN)` 判断会把这个字符串当成"已配置"而永远不再修复，
        // 导致接口地址变成 "nullnull/xxx"。因此缺失时回退到当前部署环境的默认配置。
        const appLang = localStorage.getItem('APP_LANG');
        const apiDomain = localStorage.getItem('API_DOMAIN') || APPConfig.API_DOMAIN;
        const apiDir = localStorage.getItem('API_DIR') || APPConfig.API_DIR;
        const uploadUrl = localStorage.getItem('UPLOAD_URL') || APPConfig.UPLOAD_URL;
        window.localStorage.clear();
        localStorage.setItem('API_DOMAIN', apiDomain);
        if (appLang) {
          localStorage.setItem('APP_LANG', appLang);
        }
        localStorage.setItem('API_DIR', apiDir);
        localStorage.setItem('UPLOAD_URL', uploadUrl);
        this.isLoggingOut = false;
        if (this.isContractor) {
          this.navController.navigateRoot(['login/contractor-login']);
        } else {
          this.navController.navigateRoot(['login']);
        }
      };
      const doLogout = () => {
        if (signingKey) {
          signingKey.revoke().then(finalize, finalize);
        } else {
          finalize();
        }
      };

      const url = localStorage.getItem('API_DOMAIN') + localStorage.getItem('API_DIR') + '/users/logout';
      const buildHeaders = async (): Promise<{ [key: string]: string }> => {
        const headers: { [key: string]: string } = { token };
        if (token && requestSigning) {
          const sig = await requestSigning.sign(new HttpRequest('GET', url), token);
          if (sig) {
            Object.keys(sig).forEach(k => { headers[k] = (sig as any)[k]; });
          }
        }
        return headers;
      };

      buildHeaders().then(headers => {
        this.http.get(url, { headers }).subscribe(
          () => doLogout(),
          () => doLogout()
        );
      }).catch(() => {
        this.http.get(url, { headers: { token } }).subscribe(
          () => doLogout(),
          () => doLogout()
        );
      });
    }
}
